import { useState, useCallback } from 'react';
import { TOOLS } from '../utils/constants';

// Verfügbare Segmentanzahlen für Bögen
export const ARC_SEGMENT_OPTIONS = [4, 6, 8, 12, 16, 24, 32];

export function useTools() {
  const [activeTool, setActiveTool] = useState(TOOLS.SELECT);
  const [pendingPointIds, setPendingPointIds] = useState([]);

  // Arc-Einstellungen
  const [arcSegments, setArcSegments] = useState(8); // Standard: 8 Segmente

  // Tool wechseln und pending zurücksetzen
  const selectTool = useCallback((tool) => {
    setPendingPointIds([]);
    setActiveTool(tool);
  }, []);

  // Pending Punkte zurücksetzen
  const resetPending = useCallback(() => {
    setPendingPointIds([]);
  }, []);

  // Punkt zu pending hinzufügen
  const addPendingPoint = useCallback((pointId) => {
    setPendingPointIds(prev => [...prev, pointId]);
  }, []);

  // Letzten pending Punkt entfernen
  const removeLastPending = useCallback(() => {
    setPendingPointIds(prev => prev.slice(0, -1));
  }, []);

  return {
    activeTool,
    selectTool,
    pendingPointIds,
    setPendingPointIds,
    addPendingPoint,
    removeLastPending,
    resetPending,
    // Arc-Einstellungen
    arcSegments,
    setArcSegments,
  };
}

// Re-export TOOLS für einfacheren Import
export { TOOLS };
